import { getI18n } from './get-i18n';
import { getServerContext } from './get-server-context';


export const propsAdapter = (props) => {
  const { i18n, serverContext } = props;
  return {
    i18n: getI18n(i18n),
    serverContext: getServerContext(serverContext),
  };
};
